import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { userAPI, walletAPI } from '../../services/api';
import '../../styles/admin/UserDetails.css';

const UserDetails = () => {
    const { userId } = useParams();
    const [user, setUser] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadUserDetails();
    }, [userId]);

    const loadUserDetails = async () => {
        try {
            setLoading(true);
            const userRes = await userAPI.getUserDetails(userId);
            setUser(userRes.data);
            
            const transRes = await walletAPI.getTransactions(userId, { limit: 10 });
            setTransactions(transRes.data.transactions);
        } catch (error) {
            setError(error.response?.data?.message || 'Error loading user details');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="loading">Loading user details...</div>;
    }

    if (error) {
        return <div className="alert alert-danger">{error}</div>;
    }

    if (!user) {
        return <div className="alert alert-danger">User not found</div>;
    }

    return (
        <div className="user-details">
            <div className="header">
                <h1>User Details</h1>
                <Link to={`/wallet/${userId}`} className="btn btn-success">
                    Manage Wallet
                </Link>
            </div>
            
            <div className="user-info">
                <h2>Personal Information</h2>
                <table className="info-table">
                    <tbody>
                        <tr>
                            <td>Username:</td>
                            <td><strong>{user.username}</strong></td>
                        </tr>
                        <tr>
                            <td>Email:</td>
                            <td>{user.email}</td>
                        </tr>
                        <tr>
                            <td>Phone:</td>
                            <td>{user.phone}</td>
                        </tr>
                        <tr>
                            <td>Role:</td>
                            <td>
                                <span className="badge badge-primary">{user.role}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Balance:</td>
                            <td><strong>₹{user.balance?.toLocaleString()}</strong></td>
                        </tr>
                        <tr>
                            <td>Status:</td>
                            <td>
                                <span className={`badge ${user.status === 'active' ? 'badge-success' : 'badge-danger'}`}>
                                    {user.status}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>Downline Count:</td>
                            <td>{user.downlineCount || 0}</td>
                        </tr>
                        <tr>
                            <td>Created:</td>
                            <td>{new Date(user.createdAt).toLocaleString()}</td>
                        </tr>
                        {user.parentId && (
                            <tr>
                                <td>Parent:</td>
                                <td>{user.parentId.username} ({user.parentId.role})</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            
            <div className="recent-transactions">
                <h2>Recent Transactions</h2>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Description</th>
                            <th>By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transactions.map((trans, index) => (
                            <tr key={index}>
                                <td>{new Date(trans.createdAt).toLocaleString()}</td>
                                <td>
                                    <span className={`badge ${trans.type}`}>
                                        {trans.type}
                                    </span>
                                </td>
                                <td className={trans.type === 'credit' ? 'positive' : 'negative'}>
                                    {trans.type === 'credit' ? '+' : '-'}₹{trans.amount}
                                </td>
                                <td>{trans.description}</td>
                                <td>{trans.createdBy?.username}</td>
                            </tr>
                        ))}
                        {transactions.length === 0 && (
                            <tr>
                                <td colSpan="5" className="text-center">No transactions found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default UserDetails;